const EXTERNAL = 'EXTERNAL';
const HOMEPAGE = 'HOMEPAGE';
const SEARCH_RESULTS = 'SEARCH_RESULTS';
const CHANNEL = 'CHANNEL';
const WATCH_NOW = 'WATCH_NOW';
const LEARN_MORE = 'LEARN_MORE';
const FAQ = 'FAQ';
const COMING_SOON = 'COMING_SOON';
const INTERNAL_ERROR = 'INTERNAL_ERROR';
const UNSUPPORTED_BROWSER = 'UNSUPPORTED_BROWSER';
const NOT_FOUND = 'NOT_FOUND';
const WEBINAR_REDIRECT = 'WEBINAR_REDIRECT';

export default class Page {

    static get EXTERNAL() {
        return EXTERNAL;
    }

    static get HOMEPAGE() {
        return HOMEPAGE;
    }

    static get SEARCH_RESULTS() {
        return SEARCH_RESULTS;
    }

    static get CHANNEL() {
        return CHANNEL;
    }

    static get WATCH_NOW() {
        return WATCH_NOW;
    }

    static get LEARN_MORE() {
        return LEARN_MORE;
    }

    static get FAQ() {
        return FAQ;
    }

    static get COMING_SOON() {
        return COMING_SOON;
    }

    static get INTERNAL_ERROR() {
        return INTERNAL_ERROR;
    }

    static get UNSUPPORTED_BROWSER() {
        return UNSUPPORTED_BROWSER;
    }

    static get NOT_FOUND() {
        return NOT_FOUND;
    }

    static get WEBINAR_REDIRECT() {
        return WEBINAR_REDIRECT;
    }

    static values() {
        return [EXTERNAL, HOMEPAGE, SEARCH_RESULTS, CHANNEL, WATCH_NOW,
             LEARN_MORE, FAQ, COMING_SOON, INTERNAL_ERROR, UNSUPPORTED_BROWSER, NOT_FOUND, WEBINAR_REDIRECT];
    }

}



// WEBPACK FOOTER //
// ./src/model/page.js